module.exports = __webpack_public_path__ + "img/ZGJT.afa16758.png";